import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslatePipe } from '../../../pipes/translate.pipe';
import { ProgressCardComponent } from '../../ui/progress-card/progress-card.component';
import { ToolsRecommendationComponent } from '../../tools/tools-recommendation.component';
import { SymptomClusterMapComponent } from './symptom-cluster-map.component';
import { BandScaleComponent } from '../../ui/band-scale/band-scale.component';
import { ProgressCardVM } from '../../results-vm';
import { BAND_CONFIG } from '../../results-placeholders';
import { SymptomsPanelVM } from './symptoms-vm';
import { isWebDailyLoop } from '../../../services/daily-loop';

/** paid-2 — Symptom Tracking. */
@Component({
  selector: 'app-symptoms-panel',
  standalone: true,
  imports: [CommonModule, TranslatePipe, ProgressCardComponent, ToolsRecommendationComponent, SymptomClusterMapComponent, BandScaleComponent],
  templateUrl: './symptoms-panel.component.html',
})
export class SymptomsPanelComponent {
  /** Peritale web: no app, so no "in the app" wording (Danna 27.09). */
  readonly webLoop = isWebDailyLoop();
  @Input() vm!: SymptomsPanelVM;
  @Output() goPaywall = new EventEmitter<void>();
  @Input() active = false;
  @Input() progress: ProgressCardVM | null = null;

  /** wordfirst sec 2/3 — 3-level bar config for the hero verdict. */
  readonly bandConfig = BAND_CONFIG.symptoms;
}
